module.exports = __webpack_public_path__ + "static/media/qr-code-mobile-top.192ec25e.png";